module.exports = __webpack_public_path__ + "img/020-021.1a32f6fa.jpg";